import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import RoundedButton from "Shared/RoundedButton";
import WithOpen from "Shared/WithOpen";
import ArrowDown from "src/components/icons/ArrowDown";
import GearIcon from "src/components/icons/Gear";
import GarageSettingsMenu from "../GarageSettingsMenu";
import "./GarageSettings.scss";

const renderGarageSettings = ({ t }: WithTranslation) => (isOpen: boolean, toggleOpen: any, close: any, open: any) => {
    return (
        <div className="GarageSettings">
            <RoundedButton className={`MyGarage__settingsButton`} onClick={open}>
                <GearIcon className="GarageSettings__gear-icon MyGarage__settingsButton-gear" />

                <span className={`MyGarage__settingsButton-text`}>
                    {t("MyGarage.GarageHeader.GarageSettings.garageSettingsBtn")}
                </span>

                <ArrowDown />
            </RoundedButton>

            {isOpen && <GarageSettingsMenu onClose={close} />}
        </div>
    );
};

class GarageSettings extends Component<WithTranslation> {
    public render() {
        return <WithOpen render={renderGarageSettings(this.props)} />;
    }
}

export default withTranslation()(GarageSettings);
